import section1 from './section-1/section-1.vue';
import section2 from './section-2/section-2.vue';
import section3 from './section-3/section-3.vue';
import section4 from './section-4/section-4.vue';

export default { section1, section2, section3, section4 };